export enum ParameterTypeEnum {
    None = 0,                    //brak parametru
    Fuel = 1,                    //paliwo
    Speed = 2,                   //prędkość
    //SpeedMax = 3,              //prędkość maksymalna
    //SpeedAvg = 4,              //prędkość średnia
    EngineSpeed = 5,             //obroty silnika
    Temperature = 6,             //temperatura
    Voltage = 7,                 //napięcie
    Location = 8,                //lokalizacja
    Binary = 9,                  //dwustanowy
    Analog = 10,                 //analogowy
    Digital = 11,                //cyfrowe
    Pulse = 12,                  //impulsowy
    Pressure = 13,               //ciśnienie
    Humidity = 14,               //wilgotność
    ElectricCurrent = 15,        //natężenie prądu
    Ignition = 16,               //zapłon (dwustanowy)
    Distance = 17,               //odległość (droga)
    Move = 18,                   //czujnik ruchu - wartość analogowa
    MoveBinary = 19,             //czujnik ruchu - ruch/brak ruchu
    Direction = 20,              //kierunek
    VisibleSatellites = 21,      //ilość widocznych satelitów
    GSMLevel = 22,               //poziom sygnału GSM
    RFID = 23,                   //identyfikator karty/pastylki
    Acceleration = 24,           //przyspieszenie    
    //VoltageBattery = 25,         //napięcie zasilania podtrzymującego
    Crash = 26,                  //parametr wypadku
    FuelUsage = 27,              //zużycie paliwa w pojeździe
    WorkTime = 28,               //czas pracy silnika
    GPSData = 100,
    EcoDriving = 101,             //eco driving - zbiorczy parametr (hamowania, zakręty itp.)
    VehicleStatus = 1000,         //czujnik wirtualny, oznacza bieżący status pojazdu - na potrzeby MyCarWeb
    VirtualDirection = 1001,      //parametr wirtualny, wyliczany na podstawie 2 ostatnich pozycji - na potrzeby MyCarWeb
    VirtualJoinedTemperatures = 1002, //parametr wirtualny, zwraca połączone temperatury (przyp. Elika: jest to paskudztwo; kiedy to tworzyłem to mnie mdliło) - na potrzeby MyCarWeb
    VirtualETollStatus = 1003,
    VirtualSentGeoStatus = 1005,
}